import React, { Fragment } from "react";
import packageJson from "../../../package.json";
import i18n from "locales/i18n";

const AppFooter = () => {
  return (
    <Fragment>
      <div className="app-footer">
        <div className="app-footer__inner">
          <div className="app-footer-left"></div>
          <div className="app-footer-right">
            <h6>
              {i18n.t("dashboardheading")} {packageJson.version}
            </h6>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AppFooter;
